const schema = [
  { width: 100, field: 'transactionOpportunityId', displayName: 'ID', type: 'string' },
  { width: 200, field: 'street', displayName: 'Street', type: 'string' },
  { width: 125, field: 'isSuccess', displayName: 'Success', type: 'boolean' },
  { width: 400, field: 'errorMessage', displayName: 'Autopricing Error', type: 'string' }
];

export default schema;